<div *ngIf="tieneDeuda" class="card border-warning mb-3 deuda-gracia-card" data-testid="grace-debt-card">
	<div class="card-body">
		<div class="d-flex flex-wrap justify-content-between align-items-start mb-3">
			<div class="mr-3">
				<h5 class="font-weight-bold text-dark mb-1">
					<i class="fas fa-exclamation-triangle text-warning mr-2"></i>
					Regularización por uso en periodo de gracia
				</h5>
				<p class="text-muted mb-0">
					Emitiste {{ deuda.cantidadDtes }} DTE(s) y {{ deuda.cantidadBhes }} boleta(s) de honorarios durante los 15 días de gracia del plan
					{{ deuda.nombrePlan }} sin renovar el servicio.
				</p>
			</div>
		</div>

		<div class="table-responsive">
			<table class="table table-sm table-hover mb-0">
				<thead class="thead-light">
					<tr>
						<th>Plan</th>
						<th>Vencimiento</th>
						<th>Fin de la gracia</th>
						<th class="text-center">DTEs</th>
						<th class="text-center">BHE</th>
						<th class="text-right">Neto</th>
						<th class="text-right">IVA</th>
						<th class="text-right">Total</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td class="font-weight-bold">{{ deuda.nombrePlan }}</td>
						<td>{{ deuda.fechaVencimientoPlan | date:'dd/MM/yyyy' }}</td>
						<td>{{ deuda.fechaFinGracia | date:'dd/MM/yyyy' }}</td>
						<td class="text-center" data-testid="grace-debt-dte-count">{{ deuda.cantidadDtes }}</td>
						<td class="text-center" data-testid="grace-debt-bhe-count">{{ deuda.cantidadBhes }}</td>
						<td class="text-right" data-testid="grace-debt-net">$ {{ deuda.montoNeto | number:'1.0-0':'es-CL' }}</td>
						<td class="text-right" data-testid="grace-debt-vat">$ {{ deuda.montoIva | number:'1.0-0':'es-CL' }}</td>
						<td class="text-right font-weight-bold" data-testid="grace-debt-total">$ {{ deuda.montoTotal | number:'1.0-0':'es-CL' }}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="d-flex flex-wrap justify-content-between align-items-center mt-3">
			<small class="text-muted mb-2 mb-md-0">
				{{ mensaje }}
			</small>
			<button
				type="button"
				class="btn btn-primary font-weight-bold"
				data-testid="grace-debt-pay"
				[disabled]="pagando"
				(click)="onPagar()">
				<span *ngIf="pagando" class="spinner-border spinner-border-sm mr-2"></span>
				Pagar deuda
			</button>
		</div>
	</div>
</div>
